import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarContext from '../context/SidebarContext';
// import VpnKeyIcon from "@mui/icons-material/VpnKey";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';
import MoreIcon from '@mui/icons-material/MoreVert';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import { useQueryClient } from '@tanstack/react-query';
import clsx from 'clsx';
import digitalPaaniLogoV2 from '../constants/Images/digitalPaaniLogoV2.png';
import { VatikaUserList } from '../constants/constants';
import { PERMISSION_TAGS } from '../constants/permissions';
import { useUnifiedDashboardStore } from '../store/UnifiedDashboardStore';
import useUserStore from '../store/UserStore';
import localStorageStore from '../store/localStorageStore';
import styles from '../styles/headerStyles.module.css';
import usePermissionCheck from '../utilities/customHooks/usePermissionCheck';
import { posthogIdentify } from '../utilities/helpers';
import useAuth from '../utilities/useAuth';
import { decodeToken } from '../utils/jwt.utils';
import NotificationBell from './Notifications/components/NotificationBell';
import HandleTriggerAlarmForPlantPopup from './PlantAlarmTrigger/components/plantAlarmTriggerPopup';
import UserSelectPopup from './UserSelectPopup/UserSelectPopup';
import ViewAs from './ViewAs';
import CampaignIcon from '@mui/icons-material/Campaign';
import { ErrorBoundary } from '@sentry/react';
import CommunicationIconComponent from './CommunicationPopper/components/CommunicationIconComponent';
import ProfileIconComponent from './ProfileIcon/components/ProfileIconComponent';

import VatikaLogo from '../assets/icons/vatikaLogo.png';
import { useDashboardStore } from '../store/DashboardStore';
interface propsInterface {
  plantId: string;
}

export default function Header(props: propsInterface) {
  // const { plantId } = props;
  const landingPage = useUserStore().landingPage;

  let navigate = useNavigate();
  const classes = styles;
  const profileMenuId = 'account-profile-menu';
  const mobileMenuId = 'account-profile-menu-mobile';
  const alarmMenuId = 'trigger-plant-alarm';
  // const allowAction = localStorage.getItem("allowAction");
  const allowAction = useUserStore().allowAction;
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const [anchorEl3, setAnchorEl3] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
  const moreIconRef = useRef<HTMLButtonElement | null>(null);
  const isMenu1Open = Boolean(anchorEl1);
  const isMenu3Open = Boolean(anchorEl3);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { role, isStaff } = useAuth();
  const [viewAsOpen, setViewAsOpen] = useState(false);
  const userName = useUserStore().userName;
  const isViewing = localStorage.getItem('isViewing');
  const { setToken, setSideBar, setLandingPage, setUserId, token, userId } = useUserStore();
  const { open, setOpen } = useContext(SidebarContext);
  const { resetDashboardStore } = useDashboardStore();
  const [checkoutPopup, setCheckoutPopup] = useState(false);
  const { resetUnifiedDashboardStore } = useUnifiedDashboardStore();
  const { hasPermission: canViewAs } = usePermissionCheck(
    PERMISSION_TAGS.ViewAsUser_View_R,
    '',
    isViewing
  );


  const { email } = decodeToken(token || '');

  useEffect(() => {
    if (token && userId) {
      posthogIdentify({
        distinctId: userId,
        userProperties: {
          email: email,
          name: userName,
        },
      });
    }

    let intervalId: any;

    return () => {
      clearInterval(intervalId);
    };
  }, []);



  const handleLogoClick = () => {
    const OperatorCheckedIn = localStorage.getItem('OperatorCheckedIn');
    const isOperator = OperatorCheckedIn;

    if (isOperator) {
      navigate('/task-list');
    } else {
      navigate(landingPage! || '/');
    }
  };

  //onClick handle Profile Menu
  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl1(event.currentTarget);
    setMobileMoreAnchorEl(null);
  };

  //onClick Mobile Menu Open
  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleTriggerAlarmForPlantMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl3(event.currentTarget);
    setMobileMoreAnchorEl(null);
  }



  //onClose mobile Menu
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  //onClose Profile Menu
  const handleMenu1Close = () => {
    setAnchorEl1(null);
  };
  //onClose Profile Menu
  const handleStopViewing = () => { // handle stop viewing
    queryClient.removeQueries({ queryKey: ['permissions'] });
    queryClient.removeQueries({ queryKey: ['communication-list'] });
    resetUnifiedDashboardStore();
    resetDashboardStore();
    // Revert token
    const originalToken = localStorage.getItem('originalToken');
    if (originalToken) {
      localStorage.setItem('token', originalToken);
      setToken(originalToken); // Assuming setToken is a state setter you have in context or component
      localStorage.removeItem('originalToken');
    }

    // Revert sidebar
    const originalSideBar = localStorage.getItem('originalSideBar');
    if (originalSideBar) {
      localStorage.setItem('sideBar', originalSideBar);
      setSideBar(JSON.parse(originalSideBar)); // Assuming setSideBar is a state setter
      localStorage.removeItem('originalSideBar');
    }

    // Revert userId
    const originalUserId = localStorage.getItem('originalUserId');
    if (originalUserId) {
      localStorage.setItem('userId', originalUserId);
      setUserId(originalUserId); // Assuming setUserId is a state setter
      localStorage.removeItem('originalUserId');
    }

    // Revert landing page
    const originalLandingPage = localStorage.getItem('originalLandingPage');
    if (originalLandingPage) {
      localStorage.setItem('landingPage', originalLandingPage);
      setLandingPage(originalLandingPage); // Assuming setLandingPage is a state setter
      localStorage.removeItem('originalLandingPage');
    }

    // Revert viewing state
    localStorage.removeItem('isViewing');
    localStorage.removeItem('posthogdetails');
    navigate(`${originalLandingPage}`);
  };

  const handleMenu3Close = () => {
    setAnchorEl3(null);
  };
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const queryClient = useQueryClient();
  //handle logout
  const handleLogout = () => {
    queryClient.clear();
    localStorageStore.logout();
    resetUnifiedDashboardStore();
    navigate('/Login');
  };

  const handleViewAsMenuOpen = () => {
    setViewAsOpen(true);
  };
  const handleViewAsMenuClose = () => {
    setViewAsOpen(false);
  };
  //handle checkout
  const handleCheckout = () => {};

  //Profile Dropdown
  const profileMenu = (
    <Menu
      anchorEl={anchorEl1}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={profileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenu1Open}
      onClose={handleMenu1Close}
    >
      <MenuItem
        onClick={e => {
          e.preventDefault();
          handleMenu1Close();
          navigate('/profile');
        }}
      >
        <PersonIcon className={classes.icont} />
        &nbsp; Profile
      </MenuItem>
      <MenuItem
        onClick={e => {
          e.preventDefault();
          handleMenu1Close();
          handleLogout();
        }}
      >
        <ExitToAppIcon className={classes.icont} />
        &nbsp; Logout
      </MenuItem>
      {isViewing === 'true' && (
        <MenuItem
          onClick={e => {
            e.preventDefault();
            handleMenu1Close();
            handleStopViewing();
          }}
        >
          <VisibilityIcon className={classes.icont} />
          &nbsp; Stop View As
        </MenuItem>
      )}
      {canViewAs && isViewing !== 'true' && (
        <MenuItem
          onClick={e => {
            e.preventDefault();
            handleMenu1Close();
            handleViewAsMenuOpen();
          }}
        >
          <VisibilityIcon className={classes.icont} />
          &nbsp; View As
        </MenuItem>
      )}
      {role === 'Operator Group' ? (
        <MenuItem
          onClick={e => {
            e.preventDefault();
            handleMenu1Close();
            navigate('/checkIn');
          }}
        >
          <CheckCircleIcon className={classes.icont} />
          &nbsp; Checkin
        </MenuItem>
      ) : null}

      {allowAction === true && role === 'Operator Group' ? (
        <>
          <MenuItem
            onClick={e => {
              e.preventDefault();
              handleMenu1Close();
              setCheckoutPopup(true);
              handleCheckout();
            }}
          >
            <CheckIcon className={classes.icont} />
            &nbsp; Checkout
          </MenuItem>
        </>
      ) : null}

      {role === 'Rotating Operator' ? (
        <>
          <MenuItem
            onClick={e => {
              e.preventDefault();
              handleMenu1Close();
              // setCheckoutPopup(true);
              handleCheckout();
              navigate('/checkInForRO');
            }}
          >
            <CheckIcon className={classes.icont} />
            &nbsp; Attendance
          </MenuItem>
        </>
      ) : null}
      <MenuItem
        onClick={e => {
          e.preventDefault();
          handleMenu1Close();
          navigate('/aboutPage');
        }}
      >
        <InfoIcon className={classes.icont} />
        &nbsp; About
      </MenuItem>
    </Menu>
  );

  //Notifications Dropdown

  //Mobile Dropdown
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem onClick={() => setMobileMoreAnchorEl(null)}>
           <NotificationBell key={isViewing}/>
      </MenuItem>
      {isStaff && (
      <MenuItem onClick={handleTriggerAlarmForPlantMenuOpen}>
        <IconButton
          aria-label="show Plant Alarm Trigger"
          aria-controls={alarmMenuId}
          color="inherit"
          aria-haspopup="true"
        >
        <Badge color="secondary">
                <CampaignIcon className={classes.icont} />
              </Badge>
        </IconButton>
        <p>Emergency Alarm</p>
      </MenuItem>
      )}
      
      <MenuItem >
        <CommunicationIconComponent/>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <ProfileIconComponent
          profileMenuId={profileMenuId}
          onProfileMenuOpen={handleProfileMenuOpen}
          className={classes.icont}
        />
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar
        className={`${classes.header} ${open ? classes.appBarShift : ""}`}
        sx={{ zIndex: 1201 }}
        position="fixed"
      >
        <Toolbar className={classes.header}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(true)}
            edge="start"
            className={clsx(classes.menuButton, {
              [classes.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>

          <img
            src={digitalPaaniLogoV2}
            className={classes.logo}
            alt="Digital Paani Logo"
            onClick={handleLogoClick}
          />

          <div className={classes.grow} />

          {/* ---------- DESKTOP MENU ---------- */}
          {!isMobile && (
            <div className={classes.sectionDesktop}>
              {isStaff && (
                <IconButton
                  aria-label="show Plant Alarm Trigger"
                  aria-controls={alarmMenuId}
                  color="inherit"
                  aria-haspopup="true"
                  onClick={handleTriggerAlarmForPlantMenuOpen}
                >
                  <Badge max={99} color="error">
                    <CampaignIcon className={classes.icon} />
                  </Badge>
                </IconButton>
              )}

              <NotificationBell key={isViewing} />

              <CommunicationIconComponent />

              <ProfileIconComponent
                profileMenuId={profileMenuId}
                onProfileMenuOpen={handleProfileMenuOpen}
                className={classes.icon}
                showUserName={true}
                userName={userName}
              />
            </div>
          )}

          {/* ---------- MOBILE MENU BUTTON ---------- */}
          {isMobile && (
            <div className={classes.sectionMobile}>
              <IconButton
                ref={moreIconRef}
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </div>
          )}

          {VatikaUserList?.includes(email) && (
            <Box
              sx={{
                width: 50,
                marginLeft: "10px",
                marginTop: "1px",
                background: "#fff",
                padding: "2px",
                borderRadius: "2px",
              }}
              className={"vatika-logo-container"}
            >
              <img src={VatikaLogo} alt="Vatika Logo" />
            </Box>
          )}
        </Toolbar>
      </AppBar>


      {profileMenu}

      {/* Mobile Menu */}
      {isMobile && renderMobileMenu}

      {/* Popup & other conditional components */}
      {isMenu3Open && (
        <ErrorBoundary>
          <HandleTriggerAlarmForPlantPopup
            open={isMenu3Open}
            handleClose={handleMenu3Close}
          />
        </ErrorBoundary>
      )}

      {checkoutPopup && (
        <UserSelectPopup
          type="CheckOut"
          handleClose={() => setCheckoutPopup(false)}
        />
      )}

      {viewAsOpen && (
        <ViewAs handleClose={handleViewAsMenuClose} open={viewAsOpen} />
      )}
    </div>
  );
}

Header.defaultProps = {};
